import React, { useState, useEffect } from 'react'
import { Web3Modal } from '@web3modal/react'
import { WagmiConfig } from 'wagmi'

import AdapterContext from '../contexts/AdapterContext'
import { wagmiConfig, ethereumClient } from './WalletConnectAdapter'
import { createBlockchainAdapter } from './AdapterFactory'
import {} from './BlockchainAdapter.types'
// import { DappProvider } from "@multiversx/sdk-dapp/wrappers";

interface AdapterProviderProps {
  children: React.ReactNode
  chain: string
}

const AdapterProvider: React.FC<AdapterProviderProps> = ({ children, chain }) => {
  const [adapter, setAdapter] = useState<{ [key: string]: any }>(() =>
    createBlockchainAdapter(chain),
  )

  useEffect(() => {
    setAdapter(createBlockchainAdapter(chain))
  }, [chain])

  return (
    <AdapterContext.Provider value={adapter}>
      <>
        <WagmiConfig config={wagmiConfig}>{children}</WagmiConfig>

        <Web3Modal
          projectId={process.env.REACT_APP_WALLETCONNECT_PROJECT_ID as string}
          ethereumClient={ethereumClient}
        />
      </>
    </AdapterContext.Provider>
  )
}

export default AdapterProvider
